import { render, staticRenderFns } from "./PuzzleModal.vue?vue&type=template&id=32fbfbf4&scoped=true&"
import script from "./PuzzleModal.vue?vue&type=script&lang=js&"
export * from "./PuzzleModal.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleModal.vue?vue&type=style&index=0&id=32fbfbf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbfbf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VImg,VRow})
